/**
 * Collection Press Section — standalone JS
 * Extracted from homepage-section-press.liquid inline script
 * Dependencies: Swiper (loaded globally via theme.liquid)
 */
document.addEventListener('DOMContentLoaded', function () {

    var shells = document.querySelectorAll('.collect-press-shell');

    if (!shells.length) {
        return;
    }

    /**
     * Initialise a single press instance
     */
    function initPress(shell) {
        if (shell.dataset.pressInit === 'true') {
            return;
        }

        shell.dataset.pressInit = 'true';

        var swiperEl = shell.querySelector('.collect-press-swiper');
        var slideCount = Number(shell.dataset.slideCount || 0);
        var hasControls = slideCount >= 4;

        if (!swiperEl) {
            return;
        }

        new Swiper(swiperEl, {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 8,
            loop: false,
            watchOverflow: true,
            grabCursor: hasControls,
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 8
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            },
            pagination: hasControls
                ? {
                    el: shell.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                }
                : false,
            navigation: hasControls
                ? {
                    nextEl: shell.querySelector('.collect-press-next'),
                    prevEl: shell.querySelector('.collect-press-prev')
                }
                : false
        });
    }

    /* --- Initialise all existing instances ------------ */
    shells.forEach(function (shell) {
        initPress(shell);
    });

    /* --- Shopify section-load re-initialisation ------- */
    document.addEventListener('shopify:section:load', function (event) {
        var incomingShells = event.target.querySelectorAll('.collect-press-shell');

        if (!incomingShells.length) {
            return;
        }

        incomingShells.forEach(function (shell) {
            initPress(shell);
        });
    });

});
